import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { LAYOUT_ANIMATIONS } from './layout.animations';
import { ConfigurationService } from '../_shared/services/services-index';
import { Enums, IEnums } from '../_shared/enums/enums';
import { LayoutHelperService } from './layoutHelper.service';
import { Router, NavigationStart } from '@angular/router';
import * as Models from '../_shared/models/models-index';
import { Store, select } from '@ngrx/store';
import { States } from '../_store/app.reducer';
import { selectLoggedInUser } from '../_store/app.selectors';
import { AppSelectors } from '../_store/selector-types';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Component({
    selector: 'layout',
    templateUrl: './layout.component.html',
    styleUrl: './layout.component.scss',
    animations: LAYOUT_ANIMATIONS,
    standalone: false
})
export class LayoutComponent implements OnInit, OnDestroy {
  public loading$: Observable<boolean>;
  subscriptions: Subscription[] = [];

  secondaryNavState = 'open';
  defaultSidebarState: 'open' | 'closed' = !!environment.sidebarDefaultOpen ? 'closed' : 'open'; // this is reversed intentionally so it works right
  enums: IEnums = Enums;
  authInfo: Models.IAuthenticationInfo;
  authInfo$ = this.store$.pipe(select(selectLoggedInUser));
  currentRouteData$ = this.store$.pipe(select(AppSelectors.selectCurrentRouteData));
  showFilterBar$: Observable<boolean>;
  showReportFilterBar$: Observable<boolean>;
  showAnyFilterBar$: Observable<boolean>;
  showBreadcrumb$ = this.currentRouteData$.pipe(
    map((routeData) => !routeData.hideBreadcrumbs)
  );

  constructor(
    private store$: Store<States.AppState>,
    private configService: ConfigurationService,
    public layoutHelper: LayoutHelperService,
    private router: Router) {
  }

  ngOnInit() {
    this.subscriptions.push(
      this.router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          this.layoutHelper.toggleSidebar(this.defaultSidebarState);
          this.layoutHelper.ensureMobileSidebarExpanded();
        }
      }),
      this.authInfo$.subscribe(authInfo => this.authInfo = authInfo),
    );
    this.layoutHelper.toggleSidebar(this.defaultSidebarState);
  this.syncSidebarForViewport();
    this.layoutHelper.updateCurrentCategory();

    this.showReportFilterBar$ = this.store$.select(AppSelectors.selectCurrentRouteData).pipe(
      map(routeData => {
        return !!routeData.reportName;
      })
    );

    this.showAnyFilterBar$ = this.store$.select(AppSelectors.selectCurrentRouteData).pipe(
      map(routeData => {
        return !!routeData.reportName;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.syncSidebarForViewport();
  }

  private syncSidebarForViewport(): void {
    if (typeof window === 'undefined') {
      return;
    }

    if (window.innerWidth < 992) {
      this.layoutHelper.ensureMobileSidebarExpanded();
    }
  }
}
